import React from 'react';
import { Box } from '@mui/material';
import llamaOneLogo from '../../assets/brand/llamaone-logo.png';

type LlamaLogoProps = {
  size?: number;
};

const LlamaLogo: React.FC<LlamaLogoProps> = ({ size = 72 }) => {
  return (
    <Box
      component="img"
      src={llamaOneLogo}
      alt="LLamaOne"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'block',
        userSelect: 'none',
        borderRadius: '50%',
      }}
    />
  );
};

export default LlamaLogo;
